import RankTen from '@assets/icons/rank-ten.svg'
import { Icon } from './Icon'

export const RankTenIcon = Icon(RankTen)
